<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onStartTime="onStartTime"
        @onEndTime="onEndTime"
      />
    </div>
    <div class="global-table-container">
      <a-button
        style="margin-bottom:10px;"
        type="danger"
        @click="onDeleteAll"
      >
        删除
      </a-button>
      <span
        v-show="isShowError"
        class="errorMsg"
      >请至少选择一项</span>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        @change="changePage"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <popconfirm-button
            text="删除"
            alert-title="确定删除?"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import {columns} from './data/index';
import TableSearch from './components/search.vue';
export default {
  components: {TableSearch},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      visible: false,
      id: '',
      selectedRowKeys: [],
      keyword: '',
      start_time: '',
      end_time: '',
      user_id: '',
      isShowError: false,
    };
  },
  mounted() {
    // 获取表格数据
    this.user_id=this.$route.query.id;
    this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
  },
  beforeRouteUpdate(to, from, next) {
    this.user_id=to.query.id;
    this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    next();
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      console.log('getTableData -> params', params);
      this.loading=true;
      let result = await this.$http.post('/userScoreLog/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.user_status,
            user_realname: item.user_realname,
            action: item.action,
            score: item.score>0?`+${item.score}`:item.score,
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 时间搜索
    onStartTime(value){
      this.current=1;
      this.start_time=this.$Date(value);
      this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
    onEndTime(value){
      this.current=1;
      this.end_time=this.$Date(value);
      this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },
    async onDelete(record){
      let result = await this.$http.post('/userScoreLog/del', {id: record.id});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
      }
    },
    async onDeleteAll(){
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      let result = await this.$http.post('/userScoreLog/delMore', {ids: this.selectedRowKeys.join()});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize, user_id: this.user_id, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },
  },
};
</script>
<style lang="scss" scoped>
.errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
</style>
